import { render, staticRenderFns } from "./crearSedeModal.vue?vue&type=template&id=5ef861c7"
import script from "./crearSedeModal.vue?vue&type=script&lang=js"
export * from "./crearSedeModal.vue?vue&type=script&lang=js"
import style0 from "./crearSedeModal.vue?vue&type=style&index=0&id=5ef861c7&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports